import { NoCardEntryEligibleLeaderboards as USSportsNoCardEntryEligibleLeaderboards } from '@sorare/us-sports/src/components/lobby/NoCardEntry/routes/eligible_leaderboards';

const NoCardEntryEligibleLeaderboards = () => (
  <USSportsNoCardEntryEligibleLeaderboards />
);

export default NoCardEntryEligibleLeaderboards;
